import React, {useEffect} from "react";
import CustomDropdown from "../components/CustomDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleLeft, faGear } from "@fortawesome/pro-regular-svg-icons";
import { useSidebar } from "../providers/SidebarContext";
import { useAuth } from "../providers/AuthContext";
import { useNavigate } from "react-router-dom"; // Import useNavigate

function HeaderBar() {
  const { user, logout, setRoles } = useAuth(); // Add setRoles from useAuth
  const { toggleSidebar } = useSidebar();
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    window.setRole = (role) => {
      setRoles(role);
    }
  }, []);

  return (
    <div className="h-16 p-4 justify-between flex items-center border-b-[5px] border-primary-400">
      <div className="flex items-center">
        <button onClick={toggleSidebar} className="md:hidden">
          <FontAwesomeIcon
            icon={faCircleLeft}
            className="text-xl text-primary-900 mt-1"
          />
        </button>
        <div className="logoContainer px-4 py-5 cursor-pointer" onClick={() => navigate("/")}> {/* Add cursor-pointer class */}
          <img
            src="/assets/icons/Diflex-2.png"
            alt="logo"
            className="h-[1.5rem] pr-[18px] border-r border-black"
          />
        </div>
        <div>
          <p className="text-base">{user ? user.name : "Guest"}</p>
        </div>
      </div>
      <div className="accountContainer text-primary-700 text-xs font-bold">
        {user && user.name && (
          <>
            <CustomDropdown
              isRight={true}
              ContentComponent={() => {
                return (
                  <div className="flex flex-col p-4 rounded-lg bg-white">
                    <button
                      className="flex items-center py-2 px-3"
                      onClick={logout}
                    >
                      <FontAwesomeIcon
                        icon={faCircleLeft}
                        className="text-black mr-2 text-mute-400"
                      />
                      Logout
                    </button>
                    <button className="flex items-center py-2 px-3">
                      <FontAwesomeIcon
                        icon={faGear}
                        className="text-black mr-2 text-mute-400"
                      />{" "}
                      Settings
                    </button>
                  </div>
                );
              }}
            >
              <button className="h-10 bg-primary-300 w-10 flex items-center justify-center rounded-full">{`${
                user.name.split(" ")[0][0]
              }${user.name.split(" ")[1][0]}`}</button>
            </CustomDropdown>
          </>
        )}
      </div>
    </div>
  );
}

export default HeaderBar;
